import { TFunction } from "i18next"

const EstimatorsRoleBreadCrumb = (t: TFunction<"translation", undefined>) => [
  {
    name: t("estimatorRoles.assignRoles"),
  },
]
export default EstimatorsRoleBreadCrumb
